import { useState } from 'react';

import { ReactState } from '../../typings/reactState';
import { StatesInCollection } from './interfaces/stateInCollection.interface';

export const useStateCollection = () => {
  const states: StatesInCollection = {};

  const StateCollection = <T>(stateName: string, state: T): ReactState<T> => {
    const stateArr = useState<T>(state);
    states[stateName] = {
      type: 'state',
      value: stateArr,
    };
    return stateArr;
  };

  StateCollection.addNonState = (name: string, variable: unknown) => {
    states[name] = {
      type: 'non-state',
      value: variable,
    };
    return variable;
  };

  StateCollection.getStates = () => {
    return states;
  };

  return StateCollection;
};
